import { CtaModal, CtaModalProps } from "ui/CtaModal";

import { useFetchClaimedProducts } from "../stores/useInboundDropService";

type RefetchClaimedListConfirmationModalProps = Pick<
  CtaModalProps,
  "headerIcon" | "title" | "body" | "ctaLabel"
>;

export function RefetchClaimedListConfirmationModal({
  headerIcon,
  title,
  body,
  ctaLabel,
}: RefetchClaimedListConfirmationModalProps) {
  const { fetchClaimedProducts } = useFetchClaimedProducts();
  const handleOnclick = async () => {
    await fetchClaimedProducts();
  };
  return (
    <CtaModal
      isOpen
      onClose={() => {}}
      hideCloseButton
      onClickCta={handleOnclick}
      headerIcon={headerIcon}
      title={title}
      ctaLabel={ctaLabel}
      body={body}
    />
  );
}
